'use es6';

import { memoize } from 'underscore';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const captureUnsupportedFieldMessage = memoize(props => {
  const {
    type: fieldType,
    fieldKey
  } = props;
  Raven.captureMessage('Unsupported theme field type detected', {
    extra: {
      fieldType,
      fieldKey: fieldKey.join('.')
    }
  });
}, props => {
  const {
    type: fieldType,
    fieldKey
  } = props;
  return `${fieldType}:${fieldKey.join('.')}`;
});
const unsupportedFieldHandler = props => {
  captureUnsupportedFieldMessage(props);
  return /*#__PURE__*/_jsx("div", {});
};
const getThemeSettingsFieldMap = mofoFields => {
  return {
    [FieldTypes.CHOICE]: mofoFields[FieldTypes.CHOICE],
    [FieldTypes.NUMBER]: mofoFields[FieldTypes.NUMBER],
    [FieldTypes.BOOLEAN]: mofoFields[FieldTypes.BOOLEAN],
    [FieldTypes.COLOR]: mofoFields[FieldTypes.COLOR],
    [FieldTypes.FONT]: mofoFields[FieldTypes.FONT],
    [FieldTypes.GROUP]: mofoFields[FieldTypes.GROUP],
    [FieldTypes.IMAGE]: mofoFields[FieldTypes.IMAGE]
  };
};
export const getThemeSettingsFields = mofoFields => {
  const themeSettingsFieldsMap = getThemeSettingsFieldMap(mofoFields);
  return Object.keys(FieldTypes).reduce((finalMap, key) => {
    const fieldType = FieldTypes[key];
    return Object.assign({}, finalMap, {
      [fieldType]: themeSettingsFieldsMap[fieldType] || unsupportedFieldHandler
    });
  }, {});
};